import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortCurrency'
})
export class ShortCurrencyPipe implements PipeTransform {
  transform(value: number, currencySymbol: string = 'Rs'): string {
    if (value == null || value == undefined) return 'No Data';

    let abs = Math.abs(value);
    let suffix = '';
    let shortValue = value;

    if (abs >= 1_000_000_000) {
      shortValue = value / 1_000_000_000;
      suffix = 'B';
    } else if (abs >= 1_000_000) {
      shortValue = value / 1_000_000;
      suffix = 'M';
    } else if (abs >= 1_000) {
      shortValue = value / 1_000;
      suffix = 'k';
    }
    
    if(shortValue == 0 ) {
     return "0";
    }

    return `${shortValue.toFixed(1)}${suffix} ${currencySymbol}`;
  }
}